import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

export default function useSupplierProfilesStatus() {
    const { userId, token } = useAuth();
    const [supplierProfiles, setSupplierProfiles] = useState([]);
    const [loadingProfiles, setLoadingProfiles] = useState(true);
    const [errorProfiles, setErrorProfiles] = useState(null);
    const [hasPreEvaluacion, setHasPreEvaluacion] = useState(false);
    const [hasSelloCheckin, setHasSelloCheckin] = useState(false);

    useEffect(() => {
        const fetchSupplierProfiles = async () => {
            if (!userId || !token) {
                setSupplierProfiles([]);
                setLoadingProfiles(false);
                return;
            }
            setLoadingProfiles(true);
            setErrorProfiles(null); // Clear any previous errors
            try {
                const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/supplier-profiles`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                });
                if (!response.ok) {
                    // If 404 or empty result, treat as normal (no profiles yet)
                    if (response.status === 404) {
                        setSupplierProfiles([]);
                        setLoadingProfiles(false);
                        return;
                    }
                    throw new Error(`Failed to fetch supplier profiles: ${response.status}`);
                }
                const data = await response.json();
                // Filter profiles for current userId (parseInt for robustness)
                const filtered = data.filter(item => item.supplier_id === parseInt(userId));
                setSupplierProfiles(filtered);
            } catch (error) {
                // Only set error for actual network/server errors, not for empty data
                if (error.message.includes('Failed to fetch')) {
                    setErrorProfiles(error.message);
                }
                setSupplierProfiles([]);
            } finally {
                setLoadingProfiles(false);
            }
        };
        fetchSupplierProfiles();
    }, [userId, token]);

    useEffect(() => {
        setHasPreEvaluacion(supplierProfiles.some(p => p.type === 'Pre-evaluación' && p.status === 'Aprobada'));
        setHasSelloCheckin(supplierProfiles.some(p => p.type === 'Sello Checkin' && p.status === 'Aprobada'));
    }, [supplierProfiles]);

    return {
        supplierProfiles,
        loadingProfiles,
        errorProfiles,
        hasPreEvaluacion,
        hasSelloCheckin,
    };
}